<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="Wrapper" class="flexContainerColCenter" style="overflow:auto">
            <h2>{{ $t('tournamentregistrationOverview.Header') }}</h2>
            <h3>{{ $t('tournamentregistrationOverview.Subheader1') }}</h3>
            <Grid ref="gridTurniere"
                  :style="{ width: '500px' }"
                  :data-items="gridDataTurniereComputed"
                  :loader="loaderTurniere"
                  :selected-field="selectedFieldTurniere"
                  @rowclick="onRowClickedTurniere"
                  :columns="columnsTurniere">
                <grid-norecords>{{ $t('tournamentregistrationOverview.NotificationNoData') }}</grid-norecords>
            </Grid>
            <br />
            <br />
            <h3>{{ $t('tournamentregistrationOverview.Subheader2') }}</h3>
            <radiogroup :data-items="dataItemsRadioGroup" :layout="'horizontal'" @change="handleChangeRadioGroup" :value="checked" />
            <br />
            <br />
            <h3>{{ $t('tournamentregistrationOverview.Subheader3') }}</h3>
            <div id="Anzeige">
                <kbutton title="$t('tournamentregistrationOverview.ExcelExport')" :theme-color="'primary'" @click="exportExcelWithComp">
                    {{ $t('tournamentregistrationOverview.ExcelExport') }}
                </kbutton>
                &nbsp;
                <kbutton title="$t('tournamentregistrationOverview.PDFExport')" :theme-color="'primary'" @click="exportPDFWithComp">
                    {{ $t('tournamentregistrationOverview.PDFExport') }}
                </kbutton>
                &nbsp;
                {{ gesamtStarts }}
                <br />
                <pdfexport ref="gridPDFExportEinzel"
                           :scale="0.6"
                           :paper-size="'A4'"
                           :landscape="true"
                           margin="2cm"
                           fileName="ExportEinzel.pdf">
                    <Grid v-if="visibleEinzel"
                          :style="{ height: '500px' }"
                          ref="gridAnzeigeEinzel"
                          :data-items="gridDataEinzel"
                          :loader="loaderEinzel"
                          :columns="columnsEinzel">
                        <grid-norecords>{{ $t('tournamentregistrationOverview.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </pdfexport>
                <pdfexport ref="gridPDFExportPaarTeam"
                           :scale="0.6"
                           :paper-size="'A4'"
                           :landscape="true"
                           margin="2cm"
                           fileName="ExportPaarTeam.pdf">
                    <Grid v-if="!visibleEinzel"
                          :style="{ height: '500px' }"
                          ref="gridAnzeigePaarTeam"
                          :data-items="gridDataPaarTeam"
                          :loader="loaderPaarTeam"
                          :columns="columnsPaarTeam">
                        <grid-norecords>{{ $t('tournamentregistrationOverview.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </pdfexport>
            </div>
            <br />
            <br />
        </div>
    </div>
</template>

<script>
    import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
    import { RadioGroup } from '@progress/kendo-vue-inputs';
    import { Button } from '@progress/kendo-vue-buttons';
    import { GridPdfExport } from '@progress/kendo-vue-pdf';
    import { saveExcel } from '@progress/kendo-vue-excel-export';
    import axios from 'axios';
    import config from "@/appdata/config.json";
    import store from '@/store/store.js';

    export default {
        components: {
            Grid: Grid,
            "grid-norecords": GridNoRecords,
            "grid-toolbar": GridToolbar,
            'pdfexport': GridPdfExport,
            'kbutton': Button,
            radiogroup: RadioGroup,
            store
        },
        data: function () {
            return {
                baseUrlTurniere: '',
                baseUrlEinzel: '',
                baseUrlPaarTeam: '',
                init: { method: "GET", accept: "application/json", headers: {} },
                pageable: false,
                gridDataTurniere: [],
                gridDataEinzel: [],
                gridDataPaarTeam: [],
                selectedFieldTurniere: "selectedTurniere",
                selectedPrimTurniere: 0,
                columnsTurniere: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "name", editable: false, width: 230, title: this.$t('tournamentregistrationOverview.GridColumnHeaderName') },
                    { field: "ort", editable: false, width: 120, title: this.$t('tournamentregistrationOverview.GridColumnHeaderLocation') },
                    { field: "datum", type: "date", format: "{0:dd.MM.yyyy}", editable: false, width: 100, title: this.$t('tournamentregistrationOverview.GridColumnHeaderDate') }
                ],
                columnsEinzel: [
                    { field: "klasse", editable: false, width: 300, title: this.$t('tournamentregistrationOverview.GridColumnHeaderClass') },
                    { field: "formenart", editable: false, width: 120, title: this.$t('tournamentregistrationOverview.GridColumnHeaderPoomsaetype') },
                    { field: "startnummer", editable: false, width: 85, title: this.$t('tournamentregistrationOverview.GridColumnHeaderStartNr') },
                    { field: "name", editable: false, width: 150, title: this.$t('tournamentregistrationOverview.GridColumnHeaderName') },
                    { field: "vorname", editable: false, width: 150, title: this.$t('tournamentregistrationOverview.GridColumnHeaderFirstName') },
                    { field: "form1", editable: false, width: 200, title: this.$t('tournamentregistrationOverview.GridColumnHeaderPoomsae1') },
                    { field: "form2", editable: false, width: 200, title: this.$t('tournamentregistrationOverview.GridColumnHeaderPoomsae2') }
                ],
                columnsPaarTeam: [
                    { field: "klasse", editable: false, width: 300, title: this.$t('tournamentregistrationOverview.GridColumnHeaderClass') },
                    { field: "formenart", editable: false, width: 120, title: this.$t('tournamentregistrationOverview.GridColumnHeaderPoomsaetype') },
                    { field: "startnummer", editable: false, width: 85, title: this.$t('tournamentregistrationOverview.GridColumnHeaderStartNr') },
                    { field: "anzeigeName", editable: false, width: 300, title: this.$t('tournamentregistrationOverview.GridColumnHeaderPairTeamName') },
                    { field: "form1", editable: false, width: 200, title: this.$t('tournamentregistrationOverview.GridColumnHeaderPoomsae1') },
                    { field: "form2", editable: false, width: 200, title: this.$t('tournamentregistrationOverview.GridColumnHeaderPoomsae2') }
                ],
                loaderTurniere: false,
                loaderEinzel: false,
                loaderPaarTeam: false,
                totalTurniere: 0,
                totalEinzel: 0,
                totalPaarTeam: 0,
                dataItemsRadioGroup: [
                    {
                        label: this.$t('tournamentregistrationOverview.LabelRadioGroupSingle'),
                        value: "1",
                    },
                    {
                        label: this.$t('tournamentregistrationOverview.LabelRadioGroupPairTeam'),
                        value: "2",
                    },
                ],
                checked: '1',
                visibleEinzel: true,
                gesamtStarts: '',
                maxStartsCheck: 0
            };
        },
        computed: {
            gridDataTurniereComputed() {
                return this.gridDataTurniere.map((item) => ({ prim: item.prim, name: item.name, datum: item.datum, ort: item.ort, selectedTurniere: (item.prim === this.selectedPrimTurniere) }));
            }
        },
        created: function () {
            this.baseUrlTurniere = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TurniereManagement";
            this.getDataTurniere();
        },
        methods: {
            onRowClickedTurniere(event) {
                this.selectedPrimTurniere = event.dataItem.prim;
                //Gesamtstarts und max. Gesamtanzahl anzeigen
                this.getTurniereMaxStarts();
                this.getGesamtstarts();
                //Grid neu laden
                if (this.checked === '1') {
                    this.visibleEinzel = true;
                    this.baseUrlEinzel = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TurnieranmeldungenUebersichtEinzelVereinByTurnierManagement?RefTurniere=" + this.selectedPrimTurniere + "&RefVereine=" + store.primVerein;
                    this.getDataEinzel();
                } else {
                    this.visibleEinzel = false;
                    this.baseUrlPaarTeam = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TurnieranmeldungenUebersichtPaarTeamVereinByTurnierManagement?RefTurniere=" + this.selectedPrimTurniere + "&RefVereine=" + store.primVerein;
                    this.getDataPaarTeam();
                }
            },
            getDataTurniere: function (initial) {
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlTurniere,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        that.totalTurniere = total;
                        that.gridDataTurniere = data;
                        this.loaderTurniere = false;
                    });
            },
            getDataEinzel: function (initial) {
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlEinzel,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        that.totalEinzel = total;
                        that.gridDataEinzel = data;
                        this.loaderEinzel = false;
                    });
            },
            getDataPaarTeam: function (initial) {
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlPaarTeam,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        that.totalPaarTeam = total;
                        that.gridDataPaarTeam = data;
                        this.loaderPaarTeam = false;
                    });
            },
            getTurniereMaxStarts() {
                axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/MaxStartsCheck', {
                    params: {
                        RefTurniere: this.selectedPrimTurniere
                    }
                })
                    .then((response) => {
                        this.maxStartsCheck = response.data[0].maxStartsCheck;
                        console.log("---->maxStartsCheck", this.maxStartsCheck);

                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                    })
            },
            getGesamtstarts() {
                axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/AnzahlStartsByTurniere', {
                    params: {
                        RefTurniere: this.selectedPrimTurniere
                    }
                })
                    .then((response) => {
                        this.gesamtStarts = this.$t('startsPerClub.StartsTotal') + ': ' + response.data[0].anzahl.toString() + ' / ' + this.maxStartsCheck;
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                    })
            },
            handleChangeRadioGroup(e) {
                this.checked = e.value;
                //Grid neu laden
                if (this.checked === '1') {
                    this.visibleEinzel = true;
                    this.gridDataEinzel = [];
                    this.baseUrlEinzel = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TurnieranmeldungenUebersichtEinzelVereinByTurnierManagement?RefTurniere=" + this.selectedPrimTurniere + "&RefVereine=" + store.primVerein;
                    this.getDataEinzel();
                } else {
                    this.visibleEinzel = false;
                    this.gridDataPaarTeam = [];
                    this.baseUrlPaarTeam = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TurnieranmeldungenUebersichtPaarTeamVereinByTurnierManagement?RefTurniere=" + this.selectedPrimTurniere + "&RefVereine=" + store.primVerein;
                    this.getDataPaarTeam();
                }
            },
            exportPDFWithComp: function () {
                if (this.visibleEinzel === true) {
                    this.$refs.gridPDFExportEinzel.save(this.gridDataEinzel);
                } else {
                    this.$refs.gridPDFExportPaarTeam.save(this.gridDataPaarTeam);
                }
            },
            exportExcelWithComp: function () {
                if (this.visibleEinzel === true) {
                    saveExcel({
                        data: this.gridDataEinzel,
                        fileName: "ExportEinzel",
                        columns: [
                            { field: 'klasse', title: this.$t('tournamentregistrationOverview.GridColumnHeaderClass') },
                            { field: 'formenart', title: this.$t('tournamentregistrationOverview.GridColumnHeaderPoomsaetype') },
                            { field: 'startnummer', title: this.$t('tournamentregistrationOverview.GridColumnHeaderStartNr') },
                            { field: 'name', title: this.$t('tournamentregistrationOverview.GridColumnHeaderName') },
                            { field: 'vorname', title: this.$t('tournamentregistrationOverview.GridColumnHeaderFirstName') },
                            { field: 'form1', title: this.$t('tournamentregistrationOverview.GridColumnHeaderPoomsae1') },
                            { field: 'form2', title: this.$t('tournamentregistrationOverview.GridColumnHeaderPoomsae2') }
                        ]
                    });
                } else {
                    saveExcel({
                        data: this.gridDataPaarTeam,
                        fileName: "ExportPaarTeam",
                        columns: [
                            { field: 'klasse', title: this.$t('tournamentregistrationOverview.GridColumnHeaderClass') },
                            { field: 'formenart', title: this.$t('tournamentregistrationOverview.GridColumnHeaderPoomsaetype') },
                            { field: 'startnummer', title: this.$t('tournamentregistrationOverview.GridColumnHeaderStartNr') },
                            { field: 'anzeigeName', title: this.$t('tournamentregistrationOverview.GridColumnHeaderPairTeamName') },
                            { field: 'form1', title: this.$t('tournamentregistrationOverview.GridColumnHeaderPoomsae1') },
                            { field: 'form2', title: this.$t('tournamentregistrationOverview.GridColumnHeaderPoomsae2') }
                        ]
                    });
                }
            },
        },
    };
</script>

 Add "scoped" attribute to limit CSS to this component only
<style scoped>
    @import '../css/main.css';
</style>
